import styled from 'styled-components'

import theme from 'styles/theme'
import { heading } from 'styles/typography'
import mq from 'styles/mq'
import CheckBase from 'components/icons/tick'
import CrossBase from 'components/icons/cross'

export const Section = styled.section`
  padding: 8rem 0;
  background: ${theme.color.background.light};

  ${mq.medium} {
    padding: 14rem 0;
  }
`

export const Heading = styled.h2`
  ${heading.xl};
  margin: 0 0 3.4rem;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  svg {
    display: block;
    margin: -0.2em 0 2.4rem;
  }
`

export const Th = styled.th`
  ${heading.xs};
  font-size: 1.4rem;
  margin: 0;
  text-align: left;
  width: 50%;
  padding: 2.05rem 2.4rem;
  border: 1px solid ${theme.color.border.light};
  vertical-align: top;

  ${mq.medium} {
    ${heading.m};
    font-size: 2rem;
    padding: 3rem;
    text-align: center;
  }
`

export const Td = styled.td`
  width: 50%;
  padding: 2.05rem 2.4rem;
  border: 1px solid ${theme.color.border.light};
  vertical-align: top;
  text-align: left;
  font-size: 1.2rem;

  ${mq.medium} {
    padding: 3rem;
    text-align: center;
    font-size: 1.4rem;

    svg {
      margin: 0 auto 3rem;
    }
  }

  ${mq.desktop} {
    font-size: 1.6rem;
  }
`

export const TdHeadline = styled.h3`
  ${heading.xs};
  font-size: 1.4rem;

  ${mq.medium} {
    ${heading.xs};
  }
`

export const Check = styled(CheckBase)`
  color: ${theme.color.accent.positive};
  font-size: 2.1em;
`

export const Cross = styled(CrossBase)`
  color: ${theme.color.accent.primary};
  font-size: 1.8em;
`

export const OldPrice = styled.span`
  display: inline-block;
  margin-right: 1rem;
  text-decoration: line-through;
`
